import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../public/icons/landscape/EmptyStateFilesList.svg'
import _imports_1 from '../../../../public/icons/landscape/PathIcon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-00c55964"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "calm-right-files-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = { class: "fs18" }
const _hoisted_5 = {
  key: 1,
  class: "selected-state"
}
const _hoisted_6 = { class: "collapsible-header" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = { class: "mb0 ml5" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = ["title"]
const _hoisted_11 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_12 = { class: "tooltip-path-content" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "icon theme-svg clickable"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_icon = _resolveComponent("f-icon")!
  const _component_FileSystemObjectIcon = _resolveComponent("FileSystemObjectIcon")!
  const _component_f_tooltip = _resolveComponent("f-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.selectedFiles?.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.localizer.Localize("LandscapeManagement_SelectObjects")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.localizer.Localize("LandscapeManagement_ObjectsDisplay")), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_f_icon, {
                icon: "chevronright",
                class: _normalizeClass(["clickable", { 'is-expanded': _ctx.isExpanded }]),
                onClick: _ctx.toggleExpandeCollapse
              }, null, 8, ["class", "onClick"]),
              _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.localizer.Localize("LandscapeManagement_Files")), 1)
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["collapsible-content", { open: _ctx.isExpanded }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedFiles, (Fso) => {
              return (_openBlock(), _createElementBlock("div", {
                key: Fso.id,
                class: "calm-right-file-item"
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_FileSystemObjectIcon, { Fso: Fso }, null, 8, ["Fso"]),
                  _createElementVNode("span", {
                    class: "name ml5",
                    title: Fso?.name ? Fso?.name : ''
                  }, _toDisplayString(Fso?.name), 9, _hoisted_10)
                ]),
                (!_ctx.isReadonly)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(_component_f_tooltip, null, {
                        title: _withCtx(() => [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.localizer.Localize("LandscapeManagement_Path")), 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.getPath(Fso)), 1)
                          ])
                        ]),
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_f_icon, {
                        icon: "delete",
                        class: "theme-svg clickable ml5",
                        onClick: ($event: any) => (_ctx.$emit('removeItem', false, Fso))
                      }, null, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ], 2)
        ]))
  ]))
}